import React from "react";
import { useRoutes } from "react-router-dom";
import { Chart } from "react-chartjs-2";
import { ThemeProvider } from "@material-ui/core/styles";
import validate from "validate.js";

import { chartjs } from "./helpers";
import theme from "./theme";
import "react-perfect-scrollbar/dist/css/styles.css";
import "./assets/scss/index.scss";
import validators from "./common/validators";
import routes from './routes';

Chart.helpers.extend(Chart.elements.Rectangle.prototype, {
  draw: chartjs.draw,
});

validate.validators = {
  ...validate.validators,
  ...validators,
};

// Authentication is delegated to the centralized id service: an unauthenticated
// user is redirected there (see views/ExternalSignIn), returns with a code that
// is exchanged for tokens, and the session is hydrated from those tokens on
// demand by RequireAuth -> useAuth (common/auth). No Amplify bootstrap needed.
const App = () => {
  const contents = useRoutes(routes());

  return (
    <ThemeProvider theme={theme}>
      {contents}
    </ThemeProvider>);
}

export default App;
